import styled from 'styled-components';
import { localizeNumber } from 'utils/l10n';
import { isDefined } from 'utils/tsHelpers';
import { colors, fontWeights, heading3 } from 'ui/theme';
import { useSegmentationQueryContext } from '../contexts/segmentationQuery';

export const Count = styled.div`
  ${heading3}
  color: ${colors.textDisabled};
  font-feature-settings: 'tnum';
  font-variant-numeric: lining-nums tabular-nums;
  font-weight: ${fontWeights.semiBold};

  &[data-loaded='true'] {
    color: ${colors.textPrimary};
  }
`;

export const SegmentationUsersCount = ({ dataTest }: { dataTest?: string }) => {
  const { count, isLoading, didLoad } = useSegmentationQueryContext();

  return (
    <Count data-test={dataTest} data-loaded={didLoad}>
      {isLoading ? <>&hellip;</> : (isDefined(count) && localizeNumber(count)) || '--'}
    </Count>
  );
};
